const React = require('react');


/* eslint-disable */
module.exports = (props) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={`dB strokeCT>path ` + (props.className || '')}
    >
      <path
        d="M1.5207 1.5207C1.1873 1.8541 1 2.30628 1 2.77778V3.66667C1 11.0302 6.96978 17 14.3333 17H15.2222C15.6937 17 16.1459 16.8127 16.4793 16.4793C16.8127 16.1459 17 15.6937 17 15.2222V12.3076C17 12.1209 16.9413 11.939 16.8322 11.7876C16.7231 11.6362 16.5691 11.523 16.392 11.464L12.3982 10.1324C12.1953 10.065 11.9748 10.073 11.7772 10.1549C11.5796 10.2369 11.4183 10.3873 11.3227 10.5787L10.3182 12.5849C8.14174 11.6015 6.39851 9.85826 5.41511 7.68178L7.42133 6.67733C7.61267 6.58174 7.76312 6.42036 7.84508 6.2228C7.92704 6.02524 7.93502 5.80475 7.86756 5.60178L6.536 1.608C6.47707 1.43107 6.36399 1.27716 6.21276 1.16804C6.06153 1.05893 5.87982 1.00014 5.69333 1H2.77778C2.30628 1 1.8541 1.1873 1.5207 1.5207Z"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
